/** The engagement detail page is split into tabs so operators can manage each
 *  area (audit runs, documents, billing) without one long scroll. */
export type EngagementTab = 'runs' | 'documents' | 'billing';

export const ENGAGEMENT_TAB_LABEL: Record<EngagementTab, string> = {
  runs: 'Audit runs',
  documents: 'Documents',
  billing: 'Billing',
};

/** Which tabs a viewer can see. Audit runs is always visible; Documents and
 *  Billing are practitioner-only management surfaces, and Billing hides on an
 *  archived engagement (its controls are inert once archived). */
export function availableEngagementTabs(opts: {
  isPractitioner: boolean;
  isArchived: boolean;
}): EngagementTab[] {
  const tabs: EngagementTab[] = ['runs'];
  if (opts.isPractitioner) {
    tabs.push('documents');
    if (!opts.isArchived) tabs.push('billing');
  }
  return tabs;
}

/** The active tab, falling back to 'runs' when the requested one isn't
 *  available (role change, archive, or a stale selection). */
export function resolveActiveTab(
  requested: EngagementTab,
  available: EngagementTab[],
): EngagementTab {
  return available.includes(requested) ? requested : 'runs';
}
